var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferbonus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8955 0.500977C15.3719 0.466098 16.7112 1.35248 17.2578 2.72363V2.72461C17.5664 3.50787 17.5782 4.37523 17.293 5.16406L17.0615 5.80469L17.7422 5.83398C18.7249 5.876 19.4998 6.68236 19.5 7.66699V17.333C19.5 18.5301 18.5302 19.5 17.333 19.5H2.66699C1.46977 19.5 0.5 18.5301 0.5 17.333V7.66699C0.500199 6.68524 1.27554 5.87599 2.25781 5.83398L2.93848 5.80469L2.70703 5.16406C2.42171 4.3751 2.43307 3.50782 2.74121 2.72852L2.74219 2.72754C3.25112 1.43949 4.4623 0.578682 5.8291 0.504883L6.10449 0.500977C7.45467 0.534235 8.73275 1.13248 9.62402 2.14746L10.001 2.57617L10.376 2.14746C11.2111 1.19352 12.3866 0.610128 13.6436 0.513672L13.8955 0.500977ZM2.16699 17.833H9.16699V7.50098H2.16699V17.833ZM10.833 17.833H17.833V7.50098H10.833V17.833ZM6 2.16797C4.98722 2.16797 4.16699 2.98818 4.16699 4.00098C4.16703 5.01374 4.98724 5.83398 6 5.83398H9.16699V5.33398C9.16689 3.58465 7.74939 2.16797 6 2.16797ZM14 2.16797C12.2506 2.16797 10.8331 3.58465 10.833 5.33398V5.83398H14C15.0128 5.83398 15.833 5.01374 15.833 4.00098C15.833 2.98818 15.0128 2.16797 14 2.16797Z",
    fill: "#DC3A3F",
    stroke: "#E13E3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferbonus);
export default __webpack_public_path__ + "static/media/transferbonus.df86c9ae083e4848a47f58fca446e9dc.svg";
export { ForwardRef as ReactComponent };